<template>
  <v-container class="py-10" id="socialmedia">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#d62b03">Social Media</div>
        <h2>Social Media-Kanäle</h2>
        <p>
          Bei den genutzten Social Media-Kanälen dominiert Facebook
          (<b>96%</b>). WhatsApp (<b>54%</b>) und Instagram (<b>45%</b>) nehmen
          in ihrer Popularität im Vergleich zu 2015 stark zu. Karriereportale
          wie LinkedIn und Xing werden nach wie vor kaum genutzt.
        </p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{ name: 'methodology' }"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <span>Stichprobe &amp; Methoden</span>
        </v-tooltip>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{
                name: 'comparison',
                query: { var: 'Social Media Kanäle' }
              }"
            >
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Zum Analyse-Tool</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Q7107884",
  data: () => ({}),
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: "Welche sozialen Medien benutzt Ihre Organisation?"
        },
        plotOptions: {
          series: {
            dataLabels: {
              useHTML: true,
              enabled: true,
              formatter: function() {
                return this.series.marker;
              }
            }
          }
        },
        xAxis: {
          categories: [
            "Facebook",
            "WhatsApp",
            "Instagram",
            "YouTube",
            "Twitter",
            "LinkedIn",
            //"Flickr",
            //"Wikispaces",
            "Xing"
          ]
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          shared: true,
          useHTML: true,
          valueSuffix: "%"
        },
        colors: ["#f06914", "#f0b414"],
        series: [
          {
            showInLegend: true,
            name: "2020",
            data: [96.26, 53.45, 44.9, 36.44, 24.19, 7.82, 7.33] //1.68, 0.43,
          },
          {
            showInLegend: true,
            name: "2015",
            data: [97, 32, 3, 29, 22, 3, 7] //1.68, 0.43,
          },
          {
            type: "scatter",
            showInLegend: false,
            enableMouseTracking: false,
            data: [
              {
                y: 14,
                marker: {
                  symbol: "url(/images/facebook-box.svg)",
                  width: 35,
                  height: 35
                }
              },
              {
                y: 14,
                marker: {
                  symbol: "url(/images/whatsapp.svg)",
                  width: 35,
                  height: 35
                }
              },
              {
                y: 14,
                marker: {
                  symbol: "url(/images/instagram.svg)",
                  width: 35,
                  height: 35
                }
              },
              {
                y: 14,
                marker: {
                  symbol: "url(/images/youtube.svg)",
                  width: 35,
                  height: 35
                }
              },
              {
                y: 14,
                marker: {
                  symbol: "url(/images/twitter-box.svg)",
                  width: 35,
                  height: 35
                }
              },
              {
                y: 14,
                marker: {
                  symbol: "url(/images/linkedin-box.svg)",
                  width: 35,
                  height: 35
                }
              },
              {
                y: 14,
                marker: {
                  symbol: "url(/images/xing.svg)",
                  width: 35,
                  height: 35
                }
              }
            ]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Social_Media_1",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
